import React from 'react';

import { FormattedMessage } from 'react-intl';

import { DropdownMenu } from 'ui-components/components/dropdown-menu';
import { DropdownMenuToggler } from 'ui-components/components/dropdown-menu-toggler';
import { DropdownMenuPosition } from 'ui-components/components/INTERNAL/dropdown/dropdown-menu-position';

import { AllocateShipmentMenuItem, PrintShipmentMenuItem, RestoreShipmentMenuItem, ReshipShipmentMenuItem } from './buttons';
import messages from './messages';
import { useEnableReship } from '../../../../feature-flags/hooks/use-enable-reship';

import style from './shipment-actions-dropdown.module.less';

const ShipmentActionsDropdown = () => {
  const isReshipEnabled = useEnableReship();

  return (
    <DropdownMenu
      dropdownMenuClassName={style['dropdown-menu']}
      dropdownMenuShouldHaveWidthOfButton
      menuPosition={DropdownMenuPosition.BottomRight}
    >
      <DropdownMenuToggler chevronClassname={style.chevron} className={style.toggler} theme='tertiary'>
        <FormattedMessage {...messages.shipmentActions} />
      </DropdownMenuToggler>
      <PrintShipmentMenuItem />
      <AllocateShipmentMenuItem />
      <RestoreShipmentMenuItem />
      {isReshipEnabled && <ReshipShipmentMenuItem />}
    </DropdownMenu>
  );
};

export default ShipmentActionsDropdown;
